export default class Auth {
    public token = ''
    public refreshtoken = ''
    public isAuthenticated = false

    public get bearer() {
        return `Bearer ${this.token}`
    }

    constructor() {
        const store = localStorage.getItem('auth')
        if (!store) localStorage.setItem('auth', JSON.stringify({ token: '', refreshtoken: '', isAuthenticated: false }))
        else {
            const auth = JSON.parse(store) as Auth
            this.token = auth.token
            this.refreshtoken = auth.refreshtoken
            this.isAuthenticated = auth.isAuthenticated
        }
    }

    public authentify(token: string, refreshtoken: string) {
        this.token = token
        this.refreshtoken = refreshtoken
        this.isAuthenticated = true
        localStorage.setItem('auth', JSON.stringify(this))
    }

    public verify() {
        return this.token != '' && this.refreshtoken != ''
    }

    public logout() {
        this.token = ''
        this.refreshtoken = ''
        this.isAuthenticated = false
        localStorage.setItem('auth', JSON.stringify(this))
    }
}
